import { DialogService } from 'aurelia-dialog';
import { inject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import FsUtility from '../../../../Lib/Fs.SmartClient.Client/FsUtility';
import { useView, autoinject, Container } from 'aurelia-framework'
import { EventAggregator } from 'aurelia-event-aggregator';
import { PLATFORM } from 'aurelia-pal';
import TabViewModel from '../../../../Lib/Fs.SmartClient.Client/TabViewModel';
import AirQualityIndexViewPageData from '../../Scripts/AppServiceContract/AirQualityIndexViewPageData';
import PublicAirQualityIndexViewPageAppService from '../../Scripts/AppServiceContract/PublicAirQualityIndexViewPageAppService';

@inject(DialogService)
@useView(PLATFORM.moduleName("./AirQualityIndexSearchView.html"))
export default class AirQualityIndexSearchVM extends TabViewModel{

/*  ข้อมูลสำหรับเพิ่มข้อมูลคุณภาพอากาศ*/
  AirQualityIndexViewPageData: AirQualityIndexViewPageData;
  attached() {
    this.LoadMasterData();;
  }

  constructor(dialogService) {
    super();
  }

  LoadMasterData() {
    var service = Container.instance.get(PublicAirQualityIndexViewPageAppService) as PublicAirQualityIndexViewPageAppService;
    service.LoadAirQualityIndexViewPage()
      .done((result) => {
        this.AirQualityIndexViewPageData = result;
      }).fail((error) => {
        FsUtility.AlertErrorMessage(error);
      });
  }
}
